import { CART_REVAMP_TRACKER_TYPE } from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

/**
 * @param {object} payload
 * @param {Array<object>} payload.product_infos - The list of related product information
 * @param {string} payload.product_infos[].id - The product ID
 * @param {string} payload.product_infos[].status - The product stock status (e.g. `in stock`)
 * @param {number} payload.product_infos[].rank - The rank of the product in the recommendation list
 * @param {string} payload.product_infos[].layout_setting - The layout setting of the recommendation. `horizontal_scroll`, `full`
 * @param {string} payload.product_infos[].page_type - The page type where the event is triggered
 * @param {Array<string>} payload.product_infos[].based_product_ids - The product IDs that the recommendation is based on
 * @param {string} payload.product_infos[].rec_strategy - The recommendation strategy metadata (JSON string)
 */
export const onTrackViewRelatedProducts = async ({ product_infos }) => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');

  trackerService.track({
    type: CART_REVAMP_TRACKER_TYPE.ViewRelatedProducts,
    data: {
      product_infos,
    },
  });
};
